import React from "react";
import styled from "@xstyled/styled-components";

const LabelText = styled.span`
	font-weight: bold;
`;

const About = () => (
	<div data-testid="about">
		<h2>Sup?</h2>
		<LabelText>TL;DR:</LabelText>
		<p>
			Self-taught Web Dev. React. 
		</p>

		<LabelText>Long version:</LabelText>
		<p>
			My name is Rron. I'm a self-taught web-dev. I went to Computer Science university but due to life happening and seeing the technologies 
			we learned there, I decided to step away from that and focus on teaching myself. Though a very, very, very exhausting journey, on and off 
			studying and getting myself into tutorial hell and back, it wasn't until recently I started really making stuff.
			<br/>
			Enter Starlabs. It wasn't until I got to intern at a real company and work with a real team that my knowledge just unveiled itself and I started gaining confindence to actually work on
			projects and build stuff. After I finished the internship where I worked with Laravel (PHP and MySQL) in backend, I got back to what got me hooked on programming
			in the first place, JavaScript. I've now started working/learning React.js and with the confidence gained, I've got my sunglasses on because... you know the rest.     
		</p>

		<LabelText>Technologies I've worked with include:</LabelText>
		<p>
			<ul>
				<li>HTML&CSS</li>	
				<li>SCSS</li>
				<li>Bootstrap</li>
				<li>JavaScript</li>
				<li>React.js</li>
				<li>Laravel(PHP&MySQL)</li>
			</ul>
		</p>

		<p>Feel free to hit me up!</p>
	</div>
);

export default About;